jQuery(document).ready(function($) {
    jQuery(document).ready(function($) {
        // Handling form submission via AJAX
        $(document).on('gform_confirmation_loaded', function(event, formId) {
            if (formId === 1) { // Ersetze 1 mit deiner Formular-ID
                // Do not close the modal on form submission
                $('#ModalForm').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                // Show success message within the modal
                var confirmationMessage = $('#gform_confirmation_message_' + formId);
                $('#myModal .modal-body').html(confirmationMessage);
            }
        });

        // Handling validation errors
        $(document).on('gform_post_render', function(event, formId) {
            if (formId === 1) { // Ersetze 1 mit deiner Formular-ID
                // Prevent modal from closing on form submission with errors
                $('form#gform_' + formId).on('submit', function(e) {
                    if (!$(this).valid()) {
                        e.preventDefault();
                        e.stopPropagation();
                        $('#ModalForm').modal('show'); // Keep the modal open
                    }
                });
            }
        });
    });

});
